import { onCLS, onFID, onFCP, onLCP, onTTFB } from 'web-vitals';

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    onCLS(onPerfEntry); // Captura CLS
    onFID(onPerfEntry); // Captura FID
    onFCP(onPerfEntry); // Captura FCP
    onLCP(onPerfEntry); // Captura LCP
    onTTFB(onPerfEntry); // Captura TTFB
  }
};

export default reportWebVitals;
